import { useCallback, useEffect, useState } from 'react';
import { listCustomFieldDefinitions } from '@/modules/inventory/services';
import type { CustomFieldDefinition } from '@/modules/inventory/types';

export function useCustomFields(categoryId?: string) {
  const [fields, setFields] = useState<CustomFieldDefinition[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setFields(await listCustomFieldDefinitions(undefined, categoryId));
    } catch {
      setError('No se pudieron cargar los campos personalizados.');
    } finally {
      setLoading(false);
    }
  }, [categoryId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { fields, loading, error, refresh };
}
